import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-relative" }
const _hoisted_2 = {
  class: "tw-absolute tw-pl-2",
  style: {"top":"50%","transform":"translateY(-50%)"}
}
const _hoisted_3 = {
  class: "tw-absolute tw-right-0 tw-pr-2",
  style: {"top":"50%","transform":"translateY(-50%)"}
}
const _hoisted_4 = { class: "tw-w-full flex justify-center items-center tw-bg-slate-900" }
const _hoisted_5 = ["src", "alt"]

import { PropType, ref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCarousel',
  props: {
        images:{
            type: Array as PropType<string[]>,
            default: []
        },
        height: {
            type: Number,
            default: 300
        }
    },
  setup(__props) {

    const props = __props

    let index = ref(0);

    function next(){
        index.value = (index.value + 1) % props.images.length;
    }

    function prev(){
        index.value = (index.value - 1 + props.images.length) % props.images.length;
    }

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_btn, {
        round: "",
        flat: "",
        icon: "mdi-chevron-left",
        onClick: prev,
        disable: _unref(index) === 0,
        class: "tw-bg-white tw-shadow-md tw-mr-2"
      }, null, 8, ["disable"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_btn, {
        round: "",
        flat: "",
        icon: "mdi-chevron-right",
        onClick: next,
        disable: _unref(index) === props.images.length - 1,
        class: "tw-bg-white tw-shadow-md tw-ml-2"
      }, null, 8, ["disable"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock("img", {
        src: props.images[_unref(index)],
        alt: 'Vehicle Image'+_unref(index),
        key: _unref(index),
        class: "tw-fit-contain tw-max-w-full",
        style: _normalizeStyle({ height: __props.height + 'px'})
      }, null, 12, _hoisted_5))
    ])
  ]))
}
}

})